module.exports = __webpack_public_path__ + "static/media/placeholder_image_rocks.9c0d05f3.svg";